import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../../../useApiMutation';

const useSetMarketplaceShowProfile = () => {
  const queryClient = useQueryClient();
  const mutation = useApiMutation({
    getRequestUrl: ({ showId, profileId }) => `/shows/${showId}/marketplace/profiles/${profileId}`,
    method: 'PATCH',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.showProfiles({ showId: data.showId }));
      queryClient.invalidateQueries(
        keys.showProfile({ showId: data.showId, profileId: data._id.toString() })
      );
    },
  });

  return {
    setShowProfile: mutation.mutate,
    setShowProfileAsync: mutation.mutateAsync,
    isSetShowProfileLoading: mutation.isLoading,
    isSetShowProfileError: mutation.isError,
    isSetShowProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useSetMarketplaceShowProfile;
